/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { AgentTaskStatus } from "./AgentTaskStatus";
import {
  AgentTaskStatusFromJSON,
  AgentTaskStatusFromJSONTyped,
  AgentTaskStatusToJSON,
  AgentTaskStatusToJSONTyped,
} from "./AgentTaskStatus";

/**
 *
 * @export
 * @interface AgentTaskRun
 */
export interface AgentTaskRun {
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  agentTaskRunId?: string;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  agentType?: string;
  /**
   *
   * @type {AgentTaskStatus}
   * @memberof AgentTaskRun
   */
  status?: AgentTaskStatus;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  ecsTaskArn?: string;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  callbackToken?: string;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  requestedBy?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentTaskRun
   */
  startedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentTaskRun
   */
  completedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  errorMessage?: string;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  parameters?: string;
  /**
   *
   * @type {boolean}
   * @memberof AgentTaskRun
   */
  dryRun?: boolean;
  /**
   *
   * @type {string}
   * @memberof AgentTaskRun
   */
  output?: string;
}

/**
 * Check if a given object implements the AgentTaskRun interface.
 */
export function instanceOfAgentTaskRun(value: object): value is AgentTaskRun {
  return true;
}

export function AgentTaskRunFromJSON(json: any): AgentTaskRun {
  return AgentTaskRunFromJSONTyped(json, false);
}

export function AgentTaskRunFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgentTaskRun {
  if (json == null) {
    return json;
  }
  return {
    agentTaskRunId:
      json["agentTaskRunId"] == null ? undefined : json["agentTaskRunId"],
    agentType: json["agentType"] == null ? undefined : json["agentType"],
    status:
      json["status"] == null
        ? undefined
        : AgentTaskStatusFromJSON(json["status"]),
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    ecsTaskArn: json["ecsTaskArn"] == null ? undefined : json["ecsTaskArn"],
    callbackToken:
      json["callbackToken"] == null ? undefined : json["callbackToken"],
    requestedBy: json["requestedBy"] == null ? undefined : json["requestedBy"],
    startedAt: json["startedAt"] == null ? undefined : json["startedAt"],
    completedAt: json["completedAt"] == null ? undefined : json["completedAt"],
    errorMessage:
      json["errorMessage"] == null ? undefined : json["errorMessage"],
    parameters: json["parameters"] == null ? undefined : json["parameters"],
    dryRun: json["dryRun"] == null ? undefined : json["dryRun"],
    output: json["output"] == null ? undefined : json["output"],
  };
}

export function AgentTaskRunToJSON(json: any): AgentTaskRun {
  return AgentTaskRunToJSONTyped(json, false);
}

export function AgentTaskRunToJSONTyped(
  value?: AgentTaskRun | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agentTaskRunId: value["agentTaskRunId"],
    agentType: value["agentType"],
    status: AgentTaskStatusToJSON(value["status"]),
    companyId: value["companyId"],
    shipmentId: value["shipmentId"],
    ecsTaskArn: value["ecsTaskArn"],
    callbackToken: value["callbackToken"],
    requestedBy: value["requestedBy"],
    startedAt: value["startedAt"],
    completedAt: value["completedAt"],
    errorMessage: value["errorMessage"],
    parameters: value["parameters"],
    dryRun: value["dryRun"],
    output: value["output"],
  };
}
